// extracted by mini-css-extract-plugin
module.exports = {"btn":"NavigateBackBtn_btn__1BP38","leftArrowIcon":"NavigateBackBtn_leftArrowIcon__3_tP7"};